import { Block, OneColumn } from 'components/page';
import { SubTitle } from 'components/text';
import { LojaImportacaoModeloBtn, LojaImportacaoGrid, LojaImportacaoUploadBtn } from 'pages/cadastro/loja/components';

export function LojaImportacaoComp() {
    return (
        <OneColumn title="Importação de Dados" goBackButton>
            <Block sx={{ display: 'flex', flexDirection: 'column', alignItems: { xs: 'stretch', sm: 'flex-start' }, gap: 2 }}>
                <SubTitle label="Importar Arquivo" sx={{ margin: 0 }} />

                <LojaImportacaoModeloBtn />

                <LojaImportacaoUploadBtn />
            </Block>

            <LojaImportacaoGrid />
        </OneColumn>
    );
}
